import script from "./KeyClassAnalysis.vue?vue&type=script&setup=true&lang=js"
export * from "./KeyClassAnalysis.vue?vue&type=script&setup=true&lang=js"

import "./KeyClassAnalysis.vue?vue&type=style&index=0&id=25c0753b&scoped=true&lang=css"

import exportComponent from "/Users/lidonglei/Documents/project/Dean_DHSES/dean_dhses_frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-25c0753b"]])

export default __exports__